import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {Contact} from '../../../../model/contact';

import {UserProfileFormGeneratorService} from "../../../../formulaires/user/user-profile-form-generator.service";
import {DynamicFormComponent} from "../../../../components/common/dynamic-form/dynamic-form.component";
import { QuestionControlService } from 'src/app/components/common/fields/question-control.service';
import { FieldDefinition } from 'src/app/model/field-definition';

@Component({
    selector: 'app-user-profile-form',
    imports: [
    DynamicFormComponent
],
    templateUrl: './user-profile-form.component.html',
    styleUrls: ['./user-profile-form.component.css']
})
export class UserProfileFormComponent implements OnInit {

  @Input() parentForm!: UntypedFormGroup;
  @Input() formName: string;
  @Input() profileOnly = false;
  @Input() user: Contact = null;

  questions: FieldDefinition<any>[];
  form: any;

  constructor(private userProfileFormGeneratorService: UserProfileFormGeneratorService,
              private qcs: QuestionControlService) {
  }

  ngOnInit(): void {
    this.userProfileFormGeneratorService.getQuestions(this.user, this.profileOnly).subscribe(q => {
      this.questions = q;
      if (this.parentForm.contains(this.formName)) {
        this.form = this.parentForm.controls[this.formName];
      } else {
        this.form = this.qcs.toFormGroup(this.questions, () => {
        });
        this.parentForm.setControl(this.formName, this.form);
      }
    });
  }

}
